export const PORTAL_LOCALE_KEY = "engage"
